/**
 * <product-recommendations>: fetches Shopify's recommendations for this
 * section once it nears the viewport, then swaps in the rendered rail.
 */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.querySelector('.carousel__track')) return;
    this.observer = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        this.observer.disconnect();
        this.#load();
      },
      { rootMargin: '0px 0px 400px 0px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  async #load() {
    try {
      const response = await fetch(this.dataset.url);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('product-recommendations');
      if (fresh?.querySelector('.carousel__track')) this.innerHTML = fresh.innerHTML;
    } catch {
      // Recommendations are optional; the section simply stays empty
    }
  }
}

if (!customElements.get('product-recommendations')) customElements.define('product-recommendations', ProductRecommendations);
